import React from 'react';
// The styles of the splash live with the auth panel's (class names auth-splash*): one stylesheet, one look.
import '../AuthPanel/styles.scss';
import emblemUrl from '../../img/brand/altherys-emblem.webp';
import wordmarkUrl from '../../img/brand/altherys-wordmark.webp';
import nightUrl from '../../img/brand/altherys-night.webp';

// Full-screen Altherys screen: shown while a character connects, and kept up by the client while the game loads the
// world (over the game's own loading screen), until the player can see the game.
const BrandSplash = ({ who, status }) => (
  <div className="auth-splash" role="status" aria-live="polite" style={{ backgroundImage: `url(${nightUrl})` }}>
    <div className="auth-splash__veil" />
    <div className="auth-splash__center">
      <img className="auth-splash__emblem" src={emblemUrl} alt="" />
      <img className="auth-splash__wordmark" src={wordmarkUrl} alt="Altherys" />
      {who ? <p className="auth-splash__who">{who}</p> : null}
      <div className="auth-splash__progress" aria-hidden="true" />
      <p className="auth-splash__status">{status || 'Connexion au serveur...'}</p>
    </div>
  </div>
);

export default BrandSplash;
